export const AUTH_START='AUTH_START';
export const AUTH_SUCCESS='AUTH_SUCCESS';
export const AUTH_FAIL='AUTH_FAIL';
export const AUTH_INITIATE_LOGOUT='AUTH_INITIATE_LOGOUT';
export const AUTH_LOGOUT='AUTH_LOGOUT';
export const AUTH_CHECK_TIMEOUT='AUTH_CHECK_TIMEOUT';

export const SET_AUTH_REDIRECT_PATH='SET_AUTH_REDIRECT_PATH';

export const REGISTRATION='REGISTRATION';

export const REGISTRATION_SUCCESS='REGISTRATION_SUCCESS';
export const REGISTRATION_FAIL='REGISTRATION_FAIL';
export const REGISTRATION_START='REGISTRATION_START';
export const REGISTRATION_INIT='REGISTRATION_INIT'; // value was PURCHASE_INIT 20.10.2019, changed it, but need to check if it broke something...

export const FETCH_DRIVERS_START='FETCH_ORDERS_START';
export const FETCH_DRIVERS_SUCCESS='FETCH_ORDERS_SUCCESS';
export const FETCH_DRIVERS_FAIL='FETCH_ORDERS_FAIL';
export const SET_STATUS='SET_STATUS';

export const HIDE_BOTTOMNAV_HOF='HIDE_BOTTOMNAV_HOF';
export const HIDE_BOTTOMNAV_DRIVERS='HIDE_BOTTOMNAV_DRIVERS';
export const HIDE_BOTTOMNAV_TEAMS='HIDE_BOTTOMNAV_TEAMS';


export const SET_FILTER_VALUE='SET_FILTER_VALUE';
export const SET_FILTER_KEY='SET_FILTER_KEY';
export const SET_DATA='SET_DATA';




// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js